import { MOBILE_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'

import { motion } from 'framer-motion'
import styled from 'styled-components'

export const SuccessButtonContainer = styled(motion.div)`
  width: 100%;
  height: 34px;
  background-color: ${COLORS.white};
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  cursor: pointer;
  @media screen and (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    height: 36px;
  }
`
